import AmericanSports from './_american-sports.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Text from './_text.js'
import EventListHeader from './_event-list-header.js'
import EventListGroup from './_event-list-group.js'
import InfiniteList from './_infinite-list.js'
import EventListItem from './_event-list-item.js'
import EventListMarketsSection from './_event-list-markets-section.js'
import ImageButton from './_image-button.js'

export default {
  name: 'EventList',
  values: {
    batchSize: 50,
    gameLineSports: {
      configSet: AmericanSports,
      configValues: {},
    },
    container: {
      configSet: FlexPane,
      configValues: {
        separator: {
          style: {
            size: '1px',
          },
        },
        style: {
          flexDirection: 'column',
          maxWidth: '100%',
        },
      },
    },
    sortEventsToggle: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            padding: '15px',
            minWidth: '30px',
            alignItems: 'center',
          },
        },
      },
    },
    sortEventsText: {
      configSet: Text,
      configValues: {
        style: {
          color: 'black',
        },
      },
    },
    header: {
      configSet: EventListHeader,
      configValues: {},
    },
    eventGroupsContainer: {
      configSet: FlexPane,
      configValues: {
        separator: {
          style: {
            size: '1px',
          },
        },
        style: {
          flexDirection: 'column',
        },
      },
    },
    eventListGroup: {
      configSet: EventListGroup,
      configValues: {},
    },
    eventItemsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '1px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    infiniteListItemsContainer: {
      configSet: InfiniteList,
      configValues: {
        style: {
          display: 'flex',
          flexDirection: 'column',
          gap: '1px',
        },
      },
    },
    eventItem: {
      configSet: EventListItem,
      configValues: {},
    },
    marketsSection: {
      configSet: EventListMarketsSection,
      configValues: {},
    },
    showAllEventsButton: false,
    allEventsButton: {
      configSet: ImageButton,
      configValues: {
        innerContainer: {
          itemSpacing: '2px',
          style: {
            flexDirection: 'row-reverse',
          },
        },
        button: {
          style: {
            base: {
              padding: '0 8px',
              height: '40px',
            },
          },
        },
        buttonLabel: {
          container: {
            flexGrow: 0,
          },
        },
        buttonIcon: {
          src: 'chevron-right',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
    showEarlyPayoutInHeader: false,
  },
  meta: {
    extendable: false,
  },
}
